import { useEffect, useState } from 'react';
import type { Ev1Player } from 'types/e-v1-player-api-types';
import { clearRecursiveTimeout, setRecursiveTimeout } from '~/utilities/setRecursiveTimeout';
import type { WistiaPlayer } from '@wistia/wistia-player';

export const CURRENT_TIME_INTERVAL_MS = 150;

export const useCurrentPlayerTimeLegacy = (player: Ev1Player | null): number => {
  const [result, setResult] = useState(-1);

  useEffect(() => {
    if (player != null) {
      setResult(Math.round(player.time() * 1000));
    }

    const intervalId = setRecursiveTimeout(() => {
      if (player == null) {
        return;
      }

      setResult(
        Math.round(
          player.time() * 1000 + (player.state() === 'playing' ? CURRENT_TIME_INTERVAL_MS / 2 : 0),
        ),
      );
    }, CURRENT_TIME_INTERVAL_MS);

    return () => {
      clearRecursiveTimeout(intervalId);
    };
  }, [player]);

  return result;
};

export const useCurrentPlayerTime = (player: WistiaPlayer | null): number => {
  const [result, setResult] = useState(-1);

  useEffect(() => {
    if (player != null) {
      setResult(Math.round(player.currentTime * 1000));
    }

    const intervalId = setRecursiveTimeout(() => {
      if (player == null) {
        return;
      }

      setResult(
        Math.round(
          player.currentTime * 1000 +
            (player.state === 'playing' ? CURRENT_TIME_INTERVAL_MS / 2 : 0),
        ),
      );
    }, CURRENT_TIME_INTERVAL_MS);

    return () => {
      clearRecursiveTimeout(intervalId);
    };
  }, [player]);

  return result;
};
